import { type App } from 'vue'
import { msalConfig } from '@/config/msal'

export const msalPlugin = {
  install(app: App) {
    // Make MSAL config available globally if needed
    app.config.globalProperties.$msalConfig = msalConfig
  }
}
